unit Tour;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls, WEBLib.ExtCtrls,  WEBLib.Storage,
  Vcl.Graphics, WEBLib.Buttons, WEBLib.Grids, Vcl.Grids, WEBLib.DBCtrls, XData.Web.Connection,
  Data.DB, XData.Web.JsonDataset, XData.Web.Dataset, WEBLib.DB, VCL.TMSFNCTypes, VCL.TMSFNCUtils,
  VCL.TMSFNCGraphics, VCL.TMSFNCGraphicsTypes, VCL.TMSFNCCustomControl, VCL.TMSFNCCustomPicker,
  VCL.TMSFNCComboBox, Vcl.Imaging.pngimage, XData.Web.Client, Bcl.Utils,
  VCL.TMSFNCToolBar, Vcl.Imaging.GIFImg, VCL.TMSFNCDateTimePicker, WebBasis, VCL.TMSFNCCustomComponent,
  VCL.TMSFNCBitmapContainer   ;

type
  TfrmTour = class(TfrmWebBasis)
    WebPanel1: TPanel;
    lbTau: TLabel;
    XDataWebClient: TXDataWebClient;
    btnNavPrev: TTMSFNCToolBarButton;
    btnNavNext: TTMSFNCToolBarButton;
    btnNavInfo: TTMSFNCToolBarButton;
    respGrid: TResponsiveGrid;
    dtAbfahrt: TDateTimePicker;
    cbxAbfahrt: TCheckBox;
    //
    [async] procedure Daten_Laden( aID : Integer ); async;
    [async] procedure Form_Uebersetzen; async;
    [async] procedure WebFormShow(Sender: TObject); async;
    //
    procedure WebFormCreate(Sender: TObject);
    procedure Do_DatenLaden(Sender: TObject);
    procedure btnNavInfoClick(Sender: TObject);
    procedure respGridItemDblClick(Sender: TObject; Index: Integer);
    procedure dtAbfahrtChange(Sender: TObject);
    procedure WebFormClose(Sender: TObject; var Action: TCloseAction);


  private
    bFirst : Boolean;
    iRec_Von : Integer;
    iRec_Bis : Integer;
    iID_Akt  : Integer;
    sSortFeldName : String;
    procedure Opt_Speichern;
    procedure Opt_Laden;

  public


  protected procedure LoadDFMValues; override; end;

var frmTour: TfrmTour;

const cFormTour = 'TOUR_';

implementation

{$R *.dfm}

uses UnitMain, GlobalWeb,  SpediFucsDatenmodul, TourEdit;

//====================================================================================================================//

procedure TfrmTour.btnNavInfoClick(Sender: TObject);
var iID : Integer;
begin

  iRec_Von := 1;
  iRec_Bis := frmMainForm.g_RecAnzahl;

  iID := 0;
  Daten_Laden(iID);

end;

//====================================================================================================================//

procedure TfrmTour.Opt_Laden;
var sDat, sVon, sBis : String;
    iVon, iBis : Integer;
begin

  //console.log('');
  //console.log('TfrmTau.Opt_Laden');
  cbxAbfahrt.Checked := SToB( TLocalStorage.GetValue( cFormTour +'DATUM_FILTER_EIN' ) );

  sDat := TLocalStorage.GetValue( cFormTour +'DATUM_FILTER' );
  If sDat='' then
       dtAbfahrt.DateTime := Date
  Else dtAbfahrt.DateTime := StrToDateTime(sDat);

  self.iID_Akt := StrToIntDef( TLocalStorage.GetValue( cFormTour+'ID_AKT' )  , 0);

  sVon := TLocalStorage.GetValue( cFormTour+'REC_VON' );
  sBis := TLocalStorage.GetValue( cFormTour+'REC_BIS' );

  iRec_Von := StrToIntDef( sVon  , 1);
  iRec_Bis := StrToIntDef( sBis , frmMainForm.g_RecAnzahl);

  If (iRec_Von=0) or (iRec_Bis=0) then
    Begin
      iRec_Von := 1;
      iRec_Bis := frmMainForm.g_RecAnzahl;
    End;

end;

//====================================================================================================================//

procedure TfrmTour.Opt_Speichern;
var sAbf : String;
begin

  sAbf := DateTimeToStr( Trunc( dtAbfahrt.DateTime )   );

  TLocalStorage.SetValue( cFormTour+'DATUM_FILTER_EIN', BToS( cbxAbfahrt.Checked ));
  TLocalStorage.SetValue( cFormTour+'DATUM_FILTER', sAbf );

  console.Log( cFormTour+' >> OptSpeichern '+  IntToStr(iRec_Von)+' / '+  IntToStr(iRec_Bis) );

  TLocalStorage.SetValue( cFormTour+'ID_AKT', IntToStr(self.iID_Akt) );
  TLocalStorage.SetValue( cFormTour+'REC_VON', IntToStr(self.iRec_Von) );
  TLocalStorage.SetValue( cFormTour+'REC_BIS', IntToStr(self.iRec_Bis) );

end;

//====================================================================================================================//

procedure TfrmTour.Daten_Laden( aID : Integer );
var Response: TXDataClientResponse;
    ClientConn: TXDataWebClient;
    Blob: JSValue;
    sDaten, sSQL, sTmp, sDatum, sFzg1, sFzg2 : String;
    aSL_Daten, aSL : TStringList;
    i, iAnz : Integer;
    dtAbf : TDateTime;
    aArray : TArray<string>;
    aItem : TResponsiveGridItem;
begin

  If not WaitMessage.Showing then WaitMessage.Show;

  btnNavInfo.Enabled := False;

  aSL_Daten := TStringList.Create;
  aSL := TStringList.Create;

  ClientConn := TXDataWebClient.Create(nil);
  ClientConn.Connection := frmMainForm.XDataConn;

  // 1. Touren ermitteln
 //                    0         1            2        3          4             5                6
  sSQL := '01:SELECT T.ID_TOUR, T.REF_NR, T.BEGINN, T.ENDE, T.ABRG_BEGINN, T.ABRG_ENDE, T.KND_AUFTR_NR, '
         +' (SELECT KENNZEICHEN FROM FAHRZEUG F WHERE F.ID_FAHRZEUG=T.ID_FAHRZEUG1 ) as KENNZEICHEN1, '  // 7
         +' (SELECT KENNZEICHEN FROM FAHRZEUG F WHERE F.ID_FAHRZEUG=T.ID_FAHRZEUG2 ) as KENNZEICHEN2, '  // 8
         +' (SELECT TOURNAME FROM TOUR_NAME N WHERE N.ID_TOUR_NAME=T.ID_TOUR_NAME ) as TOURNAME, '  // 9

         +' (SELECT NAME1 || IIF(NAME2 is null,'+cH+cH+', '+cH+', '+cH+' || NAME2 ) '
         +'   FROM MITARBEITER M, ADRESSE A  WHERE M.ID_ADRESSE=A.ID_ADRESSE  '
         +'   AND M.ID_MITARBEITER=T.ID_FAHRER1 ) AS FAHRER1, '

         +' (SELECT NAME1 || IIF(NAME2 is null,'+cH+cH+', '+cH+', '+cH+' || NAME2 ) '
         +'   FROM MITARBEITER M, ADRESSE A  WHERE M.ID_ADRESSE=A.ID_ADRESSE '
         +'   AND M.ID_MITARBEITER=T.ID_FAHRER2 ) AS FAHRER2, '

         +' (SELECT NAME1 FROM KUNDE K, ADRESSE A  WHERE K.ID_ADRESSE=A.ID_ADRESSE    AND K.ID_KUNDE=T.ID_KUNDE ) AS KUNDE, '
         +' (SELECT BEZEICHNUNG FROM UEBENE1 U1 WHERE U1.ID_UEBENE1=T.ID_UEBENE1) as UEBENE1, '
         +' (SELECT BEZEICHNUNG FROM UEBENE2 U2 WHERE U2.ID_UEBENE2=T.ID_UEBENE2) as UEBENE2, '

         +' (SELECT NAME1 FROM LIEFERANT L, ADRESSE A   WHERE L.ID_ADRESSE=A.ID_ADRESSE AND T.ID_LFT_FREMD=L.ID_LIEFERANT) as LFT_FREMD, '

         +' (SELECT STATUS FROM TOUR_STATUS S WHERE S.ID_TOUR_STATUS=T.ID_TOUR_STATUS ) as STATUS '
         +' FROM TOUR T '  ;

  If frmMainForm.BenutzerLftID <> '0' then
    Begin
       sSQL := sSQL + ' WHERE T.ID_LFT_FREMD = '+ frmMainForm.BenutzerLftID ;
    End
  Else If frmMainForm.BenutzerMaNr <> '0' then
    Begin
       sSQL := sSQL + ' WHERE ( T.ID_FAHRER1='+frmMainForm.BenutzerMaNr+' OR T.ID_FAHRER2='+frmMainForm.BenutzerMaNr +' )' ;
    End
  Else
    Begin
       sSQL := sSQL + ' WHERE 1=2 ' ;
    End;

  //If sTauStati <>'-1' then sSQL := sSQL + ' AND T.STATUS IN('+sTauStati+')';

  If cbxAbfahrt.Checked then
    Begin
      dtAbf := Trunc(dtAbfahrt.DateTime);
      sSQL := sSQL +' AND BEGINN >= '+cH+FormatDateTime('dd.mm.yyyy',dtAbf)+cH
                   +' AND BEGINN < ' +cH+FormatDateTime('dd.mm.yyyy',dtAbf+1)+cH;
    End;

  sSQL := sSQL + ' ORDER BY T.BEGINN DESC' +';'  ;

  console.Log('DatenLaden '+  IntToStr(iRec_Von)+' / '+  IntToStr(iRec_Bis) );

  sSQL := await(  Crypt( sSQL )  );

    Response :=  await( ClientConn.RawInvokeAsync('ISystemService.GetDatenPaket', [ sSQL, iRec_Von, iRec_Bis ] ) );
    Blob := Response.Result;
    asm sDaten = await Blob.text(); end;
  ClientConn.Free;

  aSL_Daten.Text := await( Crypt( sDaten ));

  iAnz := dmSpediFucs.Get_PaketDaten( aSL_Daten, aSL, '01');


  sTmp := aSL[0];
  aArray := sTmp.Split([';']);
  btnNavInfo.Text := aArray[3]+'-'+aArray[4]+' ['+aArray[2]+']';


  respGrid.Items.Clear;
  For i := 2 to aSL.Count -1 Do
    Begin
      sTmp := aSL[i];
      aArray := sTmp.Split([';']);

      sDatum := Copy(aArray[4],1,16);
      sFzg1  := aArray[7];
      sFzg2  := aArray[8];

      sTmp := '<p><strong>'+sDatum+ '</strong> - '+aArray[1]+'<br/>'
        +sFzg1+' - '+sFzg2+'<br />' +aArray[9]+'</p>';



      aItem := respGrid.Items.Add;
      aItem.HTML := sTmp;
      aItem.Tag :=  StrToIntDef( aArray[0], 0);

      If aArray[0] = IntToStr(self.iID_Akt) then
        Begin
          Console.Log('iID_AKT '+IntToStr(iID_Akt));
          aItem.Selected := True;
        End;

    End;

  aSL.Free;
  aSL_Daten.Free;

  btnNavNext.Enabled := (respGrid.Items.Count=frmMainForm.g_RecAnzahl );
  btnNavInfo.Enabled := True;

  If not bUebersetzt then Form_Uebersetzen;

  WaitMessage.Hide;

end;

//====================================================================================================================//

procedure TfrmTour.Do_DatenLaden(Sender: TObject);
begin

  If Sender = btnNavNext then
    Begin
     iRec_Von := iRec_Von + frmMainForm.g_RecAnzahl;
    End
  Else
    Begin
     iRec_Von := iRec_Von - frmMainForm.g_RecAnzahl;
     If iRec_Von < 1 then iRec_Von := 1;
    End;
  iRec_Bis := iRec_Von + frmMainForm.g_RecAnzahl-1;

  Daten_Laden(0);

end;

//====================================================================================================================//

procedure TfrmTour.dtAbfahrtChange(Sender: TObject);
var iID : Integer;
begin

  If (Sender=dtAbfahrt) and (cbxAbfahrt.Checked=False) then Exit;

  iRec_Von := 1;
  iRec_Bis := frmMainForm.g_RecAnzahl;

  iID := 0;

  Daten_Laden(iID);

end;

//====================================================================================================================//

procedure TfrmTour.WebFormClose(Sender: TObject; var Action: TCloseAction);
begin
  console.log('TfrmTau.OnClose');

  Opt_Speichern;

end;

//====================================================================================================================//

procedure TfrmTour.WebFormCreate(Sender: TObject);
begin

  //Console.Log('WebFormCreate----'+IntToStr( frmMainForm.g_RecAnzahl)) ;

  bFirst := False;

  XDataWebClient.Connection   := frmMainForm.XDataConn;

  iRec_Von := 1;
  iRec_Bis := frmMainForm.g_RecAnzahl;


  If Application.IsMobile then
       dtAbfahrt.Width := 95
  Else dtAbfahrt.Width := 130;


  btnNavPrev.BitmapContainer := frmMainForm.BitmapCont;
  btnNavNext.BitmapContainer := frmMainForm.BitmapCont;

  Opt_Laden;

end;

//====================================================================================================================//

procedure TfrmTour.WebFormShow(Sender: TObject);
begin

  WaitMessage.Show;

  Daten_Laden( self.iID_Akt );

end;

//====================================================================================================================//

procedure TfrmTour.respGridItemDblClick(Sender: TObject; Index: Integer);
var aItem : TResponsiveGridItem;

//  procedure AfterCreate(AForm: TObject);
//  begin
//    if Assigned(frmTauEdit) and (frmTauEdit is TfrmTauEdit) then
//      Begin
//         frmTauEdit.iID_Sprache := frmMainForm.iID_Sprache;
//         frmTauEdit.iID_Tau := aItem.Tag;
//         self.iID_Akt       := aItem.Tag;
//
//        frmTauEdit.Sprach_Daten_Laden('TAUEDIT', frmMainForm.iID_Sprache );
//
//         console.log('respGridItemDblClick: ' +IntToStr(iID_Akt) );
//      End;
//  end;

begin

  aItem := respGrid.Items[Index] ;

  self.iID_Akt := aItem.Tag;

  Opt_Speichern;

  DoTourEdit( aItem.Tag );


end;

//====================================================================================================================//
//
//procedure TfrmTau.SprachDaten_Laden( aID_Sprache : Integer =0 );
//var Response: TXDataClientResponse;
//    ClientConn: TXDataWebClient;
//    Blob: JSValue;
//    sDaten, sSQL, sTmp : String;
//    aSL : TStringList;
//    aStream : TStream;
//    i : Integer;
//    aArray : TArray<string>;
//begin
//
//  If not WaitMessage.Showing then WaitMessage.Show;
//
//  ClientConn := TXDataWebClient.Create(nil);
//  ClientConn.Connection := frmMainForm.XDataConn;
//    Response := await( ClientConn.RawInvokeAsync('ISystemService.GetSprachDaten', ['TAU',aID_Sprache] ) );
//    Blob := Response.Result;
//    asm sDaten = await Blob.text(); end;
//  ClientConn.Free;
//
//  aSL := TStringList.Create;
//  aSL.Text := await( Crypt( sDaten)) ;
//
//  console.Log(  aSL.Text  );
//
//  tabSprachDaten.Close;
//  tabSprachDaten.Open;
//
//  If aSL.Count > 2 then
//    For i := 2 to aSL.Count -1 Do
//        Begin
//         sTmp := aSL[i];
//          aArray := sTmp.Split([';']);
//          tabSprachDaten.Append;
//          tabSprachDaten.FieldByName('NUMMER').AsInteger     := StrToIntDef(aArray[0],0);
//          tabSprachDaten.FieldByName('BEGRIFF').AsString  := aArray[1];
//          tabSprachDaten.FieldByName('BEGRIFF_UEB').AsString  := aArray[2];
//          console.Log( 'SprachDaten_Laden: ' + tabSprachDaten.FieldByName('BEGRIFF').AsString +' ' +  tabSprachDaten.FieldByName('BEGRIFF_UEB').AsString  );
//
//          tabSprachDaten.Post;
//        End;
//
//  aSL.Free;
//
//  Form_Uebersetzen;
//
//  WaitMessage.Hide;
//
//end;

//====================================================================================================================//

procedure TfrmTour.Form_Uebersetzen;
begin


  If not tabSprachDaten.Active then
    Begin
     console.Log( 'Form_Uebersetzen in TfrmTau -> NICHT OFFFEN');
     Exit;
    End;

  console.Log( 'Form_Uebersetzen in TfrmTau');

  If tabSprachDaten.Locate('NUMMER', 10, [] ) then lbTau.Caption    := tabSprachDatenBEGRIFF_UEB.AsString;

  console.Log( 'Form_Uebersetzen in TfrmTau3: '+tabSprachDatenBEGRIFF_UEB.AsString);

  self.bUebersetzt := True;


end;


//====================================================================================================================//

procedure TfrmTour.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WebPanel1 := TPanel.Create(Self);
  lbTau := TLabel.Create(Self);
  btnNavPrev := TTMSFNCToolBarButton.Create(Self);
  btnNavNext := TTMSFNCToolBarButton.Create(Self);
  btnNavInfo := TTMSFNCToolBarButton.Create(Self);
  dtAbfahrt := TDateTimePicker.Create(Self);
  cbxAbfahrt := TCheckBox.Create(Self);
  respGrid := TResponsiveGrid.Create(Self);
  XDataWebClient := TXDataWebClient.Create(Self);

  WebPanel1.BeforeLoadDFMValues;
  lbTau.BeforeLoadDFMValues;
  btnNavPrev.BeforeLoadDFMValues;
  btnNavNext.BeforeLoadDFMValues;
  btnNavInfo.BeforeLoadDFMValues;
  dtAbfahrt.BeforeLoadDFMValues;
  cbxAbfahrt.BeforeLoadDFMValues;
  respGrid.BeforeLoadDFMValues;
  BitmapCont.BeforeLoadDFMValues;
  tabSprachDaten.BeforeLoadDFMValues;
  XDataWebClient.BeforeLoadDFMValues;
  try
    Width := 1436;
    Height := 533;
    Color := 16776441;
    FormContainer := 'appcontent';
    SetEvent(Self, 'OnShow', 'WebFormShow');
    WebPanel1.SetParentComponent(Self);
    WebPanel1.Name := 'WebPanel1';
    WebPanel1.Left := 0;
    WebPanel1.Top := 0;
    WebPanel1.Width := 1436;
    WebPanel1.Height := 90;
    WebPanel1.Align := alTop;
    WebPanel1.BorderColor := 16776441;
    WebPanel1.Color := 16776441;
    WebPanel1.ElementFont := efCSS;
    WebPanel1.TabOrder := 0;
    lbTau.SetParentComponent(WebPanel1);
    lbTau.Name := 'lbTau';
    lbTau.Left := 16;
    lbTau.Top := 8;
    lbTau.Width := 64;
    lbTau.Height := 18;
    lbTau.Caption := 'Touren';
    lbTau.Font.Charset := DEFAULT_CHARSET;
    lbTau.Font.Color := clBlack;
    lbTau.Font.Height := -16;
    lbTau.Font.Name := 'Verdana';
    lbTau.Font.Style := [fsBold];
    lbTau.HeightPercent := 100.000000000000000000;
    lbTau.ParentFont := False;
    lbTau.WidthPercent := 100.000000000000000000;
    btnNavPrev.SetParentComponent(WebPanel1);
    btnNavPrev.Name := 'btnNavPrev';
    btnNavPrev.Left := 5;
    btnNavPrev.Top := 34;
    btnNavPrev.Width := 65;
    btnNavPrev.Height := 44;
    btnNavPrev.Cursor := crHandPoint;
    btnNavPrev.ParentDoubleBuffered := False;
    btnNavPrev.DoubleBuffered := True;
    btnNavPrev.Font.Charset := DEFAULT_CHARSET;
    btnNavPrev.Font.Color := clWindowText;
    btnNavPrev.Font.Height := -11;
    btnNavPrev.Font.Name := 'Segoe UI';
    btnNavPrev.Font.Style := [];
    btnNavPrev.ParentColor := True;
    btnNavPrev.TabOrder := 0;
    SetEvent(btnNavPrev, Self, 'OnClick', 'Do_DatenLaden');
    btnNavPrev.Text := '';
    btnNavPrev.Bitmaps.Clear;
    with btnNavPrev.Bitmaps.Add do
    begin
      BitmapName := 'LINKS';
    end;
    btnNavPrev.BitmapVisible := True;
    btnNavPrev.BitmapContainer := BitmapCont;
    btnNavPrev.ControlIndex := 0;
    btnNavNext.SetParentComponent(WebPanel1);
    btnNavNext.Name := 'btnNavNext';
    btnNavNext.Left := 181;
    btnNavNext.Top := 34;
    btnNavNext.Width := 65;
    btnNavNext.Height := 44;
    btnNavNext.Cursor := crHandPoint;
    btnNavNext.ParentDoubleBuffered := False;
    btnNavNext.DoubleBuffered := True;
    btnNavNext.Font.Charset := DEFAULT_CHARSET;
    btnNavNext.Font.Color := clWindowText;
    btnNavNext.Font.Height := -11;
    btnNavNext.Font.Name := 'Segoe UI';
    btnNavNext.Font.Style := [];
    btnNavNext.ParentColor := True;
    btnNavNext.TabOrder := 1;
    SetEvent(btnNavNext, Self, 'OnClick', 'Do_DatenLaden');
    btnNavNext.Text := '';
    btnNavNext.Bitmaps.Clear;
    with btnNavNext.Bitmaps.Add do
    begin
      BitmapName := 'RECHTS';
    end;
    btnNavNext.BitmapVisible := True;
    btnNavNext.BitmapContainer := BitmapCont;
    btnNavNext.ControlIndex := 0;
    btnNavInfo.SetParentComponent(WebPanel1);
    btnNavInfo.Name := 'btnNavInfo';
    btnNavInfo.Left := 74;
    btnNavInfo.Top := 34;
    btnNavInfo.Width := 103;
    btnNavInfo.Height := 44;
    btnNavInfo.Cursor := crHandPoint;
    btnNavInfo.Hint := 'Daten laden';
    btnNavInfo.ParentDoubleBuffered := False;
    btnNavInfo.DoubleBuffered := True;
    btnNavInfo.Font.Charset := ANSI_CHARSET;
    btnNavInfo.Font.Color := clWindowText;
    btnNavInfo.Font.Height := -13;
    btnNavInfo.Font.Name := 'Verdana';
    btnNavInfo.Font.Style := [];
    btnNavInfo.ParentColor := True;
    btnNavInfo.TabOrder := 2;
    SetEvent(btnNavInfo, Self, 'OnClick', 'btnNavInfoClick');
    btnNavInfo.Text := '1 - 50 [254]';
    btnNavInfo.ControlIndex := 0;
    dtAbfahrt.SetParentComponent(WebPanel1);
    dtAbfahrt.Name := 'dtAbfahrt';
    dtAbfahrt.Left := 253;
    dtAbfahrt.Top := 34;
    dtAbfahrt.Width := 117;
    dtAbfahrt.Height := 44;
    dtAbfahrt.Cursor := crHandPoint;
    dtAbfahrt.BorderStyle := bsSingle;
    dtAbfahrt.ChildOrder := 5;
    dtAbfahrt.Color := 15329769;
    dtAbfahrt.Date := 45767.262767685180000000;
    dtAbfahrt.Role := '';
    dtAbfahrt.ShowSeconds := False;
    dtAbfahrt.Text := '';
    SetEvent(dtAbfahrt, Self, 'OnChange', 'dtAbfahrtChange');
    cbxAbfahrt.SetParentComponent(WebPanel1);
    cbxAbfahrt.Name := 'cbxAbfahrt';
    cbxAbfahrt.Left := 253;
    cbxAbfahrt.Top := 0;
    cbxAbfahrt.Width := 100;
    cbxAbfahrt.Height := 33;
    cbxAbfahrt.Cursor := crHandPoint;
    cbxAbfahrt.Caption := 'Abfahrt';
    cbxAbfahrt.ChildOrder := 6;
    cbxAbfahrt.HeightPercent := 100.000000000000000000;
    cbxAbfahrt.WidthPercent := 100.000000000000000000;
    SetEvent(cbxAbfahrt, Self, 'OnClick', 'dtAbfahrtChange');
    respGrid.SetParentComponent(Self);
    respGrid.Name := 'respGrid';
    respGrid.Left := 0;
    respGrid.Top := 90;
    respGrid.Width := 1436;
    respGrid.Height := 443;
    respGrid.Cursor := crHandPoint;
    respGrid.ElementClassName := 'respgrid';
    respGrid.HeightStyle := ssAuto;
    respGrid.WidthStyle := ssPercent;
    respGrid.WidthPercent := 90.000000000000000000;
    respGrid.Align := alClient;
    respGrid.ChildOrder := 3;
    respGrid.Font.Charset := ANSI_CHARSET;
    respGrid.Font.Color := clWindowText;
    respGrid.Font.Height := -13;
    respGrid.Font.Name := 'Verdana';
    respGrid.Font.Style := [];
    respGrid.ItemIndex := 0;
    respGrid.Options.ItemClassName := 'respitem';
    respGrid.Options.ItemColor := 16639703;
    respGrid.Options.ItemHeight := 70;
    respGrid.Options.ItemHoverColor := 14811135;
    respGrid.Options.ItemSelectedColor := clBisque;
    respGrid.Options.ItemPadding := 10;
    respGrid.Options.ItemWidthMin := 260;
    respGrid.ParentFont := False;
    SetEvent(respGrid, Self, 'OnItemClick', 'respGridItemDblClick');
    BitmapCont.Left := 423;
    BitmapCont.Top := 34;
    tabSprachDaten.Left := 96;
    tabSprachDaten.Top := 104;
    XDataWebClient.SetParentComponent(Self);
    XDataWebClient.Name := 'XDataWebClient';
    XDataWebClient.Left := 192;
    XDataWebClient.Top := 216;
  finally
    WebPanel1.AfterLoadDFMValues;
    lbTau.AfterLoadDFMValues;
    btnNavPrev.AfterLoadDFMValues;
    btnNavNext.AfterLoadDFMValues;
    btnNavInfo.AfterLoadDFMValues;
    dtAbfahrt.AfterLoadDFMValues;
    cbxAbfahrt.AfterLoadDFMValues;
    respGrid.AfterLoadDFMValues;
    BitmapCont.AfterLoadDFMValues;
    tabSprachDaten.AfterLoadDFMValues;
    XDataWebClient.AfterLoadDFMValues;
  end;
end;

end.

